import * as Preact from "preact"
import Chapter from "@frog/source/models/Chapter.js"
import games from "@frog/source/data/games/index.js"

import Camera from "@frog/source/views/components/Camera.jsx"
import Unit from "@frog/source/views/components/Unit.jsx"
import App from "@frog/source/models/App.js"
import Zone from "@frog/source/models/Zone.js"
import Director from "@frog/source/juice/Director.js"

import "@frog/source/views/SkillPreviewUI.less"

export default class SkillPreview {
    constructor(props) {
        this.loadDemonstrationChapter(props.demo)
    }
    loadDemonstrationChapter(demo) {
        if(demo == undefined) {
            App.previewChapter = undefined
            return
        }
        App.previewChapter = Chapter.load({
            "chapter": games[demo.gameSlug].chapters[demo.chapterSlug],
            "player": demo.player,
            "gameslug": demo.gameSlug,
            "randomSeed": demo.randomSeed,
        }, {"isBlockingSideEffects": true, "animationSequence": {"steps": []}})
        App.previewChapter.replaySavestateFromActiontrace(demo, {"isShowingEveryStep": true})
    }
    render() {
        return (
            <div class="Preview"
                onPointerOver={() => this.loadDemonstrationChapter(this.props.demo)}>
                <Stage chapter={App.previewChapter}/>
            </div>
        )
    }
}

class Stage {
    render() {
        if(this.props.chapter == undefined) return
        const stage = this.getActiveStage()

        return (
            <div class="Stage">
                <Camera chapter={this.props.chapter}>
                    <WorldImage stage={stage}/>
                    <Units stage={stage}/>
                </Camera>
            </div>
        )
    }
    getActiveStage() {
        const sequence = this.props.chapter.sequence

        if(sequence != undefined
        && sequence.steps != undefined
        && sequence.steps[0] != undefined
        && sequence.steps[0].stage != undefined) {
            return sequence.steps[0].stage
        }
        if(sequence != undefined
        && sequence.steps != undefined
        && sequence.steps[0] != undefined
        && sequence.steps[0].omegastage != undefined) {
            return sequence.steps[0].omegastage
        }
        return this.props.chapter.stage
    }
}

class Units {
    render() {
        const stage = this.props.stage
        return Object.values(stage.units).map((unit, index) => {
            if(unit == undefined) return
            if(unit.isDead == true) return
            if(unit.hasBeenRemoved == true) return
            if(unit.isNotRendered) return

            return <Unit stage={stage} unit={unit}/>
        })
    }
}

class WorldImage {
    render() {
        if(this.props.stage.images != undefined) {
            return this.props.stage.images.map((image, index) => {
                return (
                    <div class="WorldImage" style={{
                        "background-image": "url(" + image + ")",
                        "width": this.props.stage.world.width + "em",
                        "height": this.props.stage.world.height + "em",
                        "z-index": 1 + (index * 10),
                    }}/>
                )
            })
        }
        return (
            <div class="WorldImage" style={{
                "background-image": "url(" + this.props.stage.image + ")",
                "width": this.props.stage.world.width + "em",
                "height": this.props.stage.world.height + "em",
            }}>
                {this.encounters}
            </div>
        )
    }
    get encounters() {
        if(this.props.stage.encounters == undefined) return
        return Object.values(this.props.stage.encounters).map((encounter) => {
            if(this.props.stage.currentEncounterKey < encounter.slug) return
            if(encounter.color == undefined) return
            return (
                <div class="EncounterImage" style={{
                    "width": encounter.width + "em",
                    "height": encounter.height + "em",
                    "left": encounter.x + "em",
                    "top": encounter.y + "em",
                    "backgroundColor": encounter.color,
                }}/>
            )
        })
    }
}
